export default __webpack_public_path__ + "static/media/IBMPlexMono-Regular-Pi.987d18f1.woff2";